import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mt-0" }
const _hoisted_2 = {
  key: 0,
  d: "M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z",
  "fill-rule": "evenodd",
  sandboxuid: "0"
}
const _hoisted_3 = {
  key: 1,
  d: "M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z",
  sandboxuid: "0"
}
const _hoisted_4 = { class: "d-grid gap-2" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = {
  style: {"font-size":"12px"},
  class: "d-flex justify-space-between"
}
const _hoisted_7 = { class: "d-flex search-buttons" }

import OperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue'
import AccountAutoComplete from '@/components/AutoCompletes/AccountAutoComplete.vue';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import RangeDatePicker from '@/components/Common/RangeDatePicker.vue';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getAccountResponse from '@/types/responses/getAccount';
import { Ref, reactive, ref, computed, watch } from "vue";
import {
  SELECTABLE_AUDITABLE_TYPE_ITEMS,
  SELECTABLE_EVENT_ITEMS
} from '@/services/consts';
import i18n from "@/lang/i18n"

type formType = {
  page: number,
  auditable_type: string | null,
  auditable_id: number | null,
  event: string | null,
  operationOffice: getOperationOffice | undefined
  account: getAccountResponse | undefined,
  daterange: Date[]
}

const DEFAULT_BACK_DAYS = 6

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchForm',
  props: {
    isLoading: { type: Boolean },
    errors: {}
  },
  emits: ['search', 'formchange'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const TODAY = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
const BEFORE_DAY = new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate() - DEFAULT_BACK_DAYS)
const hide: Ref<boolean> = ref(false)
const form: formType = reactive({
  page: 1,
  auditable_type: null,
  auditable_id: null,
  operationOffice: undefined,
  event: null,
  account: undefined,
  daterange: [
    BEFORE_DAY,
    TODAY
  ]
})

const title = computed(() => {
  return hide.value ? "" : i18n.global.t('pages.common.filter.title')
})

const searchAreaClass = computed(() => {
  return hide.value ? "search-area-hide p-4" : "search-area p-4"
})

const changeSearchButton = computed(() => {
  return props.isLoading ? i18n.global.t('pages.common.button.loading') : i18n.global.t('pages.common.button.exec')
})

function clearForm () {
  form.auditable_type = null
  form.auditable_id = null
  form.event = ''
  form.operationOffice = undefined
  form.account = undefined
  form.daterange = [
    BEFORE_DAY,
    TODAY
  ]
}

function toggleSidebar () {
  hide.value = !hide.value
}

function handleClickSearch() {
  emits('search', form)
}

watch(form, () => {
  emits('formchange', form)
})

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(searchAreaClass.value)
  }, [
    _createElementVNode("h4", _hoisted_1, [
      _createTextVNode(_toDisplayString(title.value) + " ", 1),
      (_openBlock(), _createElementBlock("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fit: "",
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        sandboxuid: "0",
        onClick: toggleSidebar
      }, [
        (hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
          : _createCommentVNode("", true),
        (!hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`strpied-tabled-with-hover ${hide.value ? 'd-none' : '' }`)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(OperationOfficeAutoComplete, {
          modelValue: form.operationOffice,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.operationOffice) = $event)),
          "error-messages": props.errors.operation_office_id,
          selectFirstIfOnlyOne: "",
          clearable: false
        }, null, 8, ["modelValue", "error-messages"]),
        _createVNode(AccountAutoComplete, {
          modelValue: form.account,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.account) = $event)),
          operationOfficeId: form.operationOffice?.id,
          operationOfficeOnly: true
        }, null, 8, ["modelValue", "operationOfficeId"]),
        _createVNode(_component_v_select, {
          modelValue: form.auditable_type,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.auditable_type) = $event)),
          items: _unref(SELECTABLE_AUDITABLE_TYPE_ITEMS),
          "item-title": "name",
          "item-value": "value",
          label: _unref(i18n).global.t('pages.auditLog.list.auditableType')
        }, null, 8, ["modelValue", "items", "label"]),
        _createVNode(_component_v_select, {
          modelValue: form.event,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.event) = $event)),
          items: _unref(SELECTABLE_EVENT_ITEMS),
          class: "mb-2",
          "item-title": "name",
          "item-value": "value",
          label: _unref(i18n).global.t('pages.auditLog.list.event')
        }, null, 8, ["modelValue", "items", "label"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ValidationErrors, {
          messages: props.errors.daterange
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(RangeDatePicker, {
                modelValue: form.daterange,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.daterange) = $event)),
                maxRange: DEFAULT_BACK_DAYS,
                format: 'yyyy/MM/dd',
                isError: props.errors.daterange?.length > 0
              }, null, 8, ["modelValue", "isError"])
            ])
          ]),
          _: 1
        }, 8, ["messages"]),
        _createVNode(_component_v_divider, {
          thickness: 3,
          class: "my-2"
        }),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_btn, {
            class: "ma-2 exec-btn",
            onClick: handleClickSearch,
            disabled: props.isLoading,
            style: _normalizeStyle({
              backgroundColor : props.isLoading ? '#B3B8BB' : ''
            })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(changeSearchButton.value), 1)
            ]),
            _: 1
          }, 8, ["disabled", "style"]),
          _createVNode(_component_v_btn, {
            class: "ma-2 reset-btn",
            disabled: props.isLoading,
            onClick: clearForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ], 2)
  ], 2))
}
}

})